import React from 'react';

import { observer } from 'mobx-react-lite';

import {
  TableFooter,
  parseNumberByPrecision,
  DefaultQueryParams,
  parseQuery,
} from '@pascal/pascal-core';
import {
  roundInfoStore,
  userCountStore,
  userInfoStore,
} from '@pascal/pascal-core/shared/core/store';

import { useLocation } from 'react-router-dom';
import { doBetStore } from '../../store/doBetStore';
import { winningAmountStore } from '../../store/winningAmountStore';
import { TURBO_OR_TERMINAL_GAME_ID } from '../../enums/constants';

const secondNumber = 1;

const FooterWr = observer(() => {
  const { roundId } = roundInfoStore;
  const { betsTotalAmount } = doBetStore;
  const { usersCount } = userCountStore;
  const { lastWinAmount } = winningAmountStore;
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_OR_TERMINAL_GAME_ID;

  return (
    <TableFooter
      lastWin={lastWinAmount}
      roundId={`${roundId}`}
      usersCount={usersCount}
      totalBet={parseNumberByPrecision(betsTotalAmount, secondNumber, +userInfoStore.precision)}
      additionalCountChecker={!isTurbo}
    />
  );
});

export default FooterWr;
